import { channelTypeInfo } from "../models/ChannelType";
import Device from "../models/Device";
import GroupAddress from "../models/GroupAdress";
import { itx } from "../translationItx/itx";
import { getGaFromCollection } from "./AddressGeneratorUtils";
import { createButtonAddresses_3 } from "./createButtonAddresses";
import generateAddressesForConsumer_B from "./generateAddressesForConsumer_B";

// Impementiert folgendes Schema:
//
// (Etage & Raum) / Verbraucher / Signal
//

export function createAddresses_B() {
  state.floors.sortBy("tagOrName").forEach((floor) => {
    floor.rooms.sortBy("tagOrName").forEach((room) => {
      if (room.isFloorGeneralRoom && room.buttons.size == 0 && room.consumers.size == 0) {
        //
        // Skip general floor rooms without buttons or consumers
        //
        return;
      }

      // Level 1 Address (Etage-Raum)

      let name = `${floor.tag} - `;
      if (room.isFloorGeneralRoom) {
        name += itx("createAddressesB.allgemein", "Allgemein");
      } else {
        name += room.name;
      }

      let mainGroup = room.groupAddress;
      if (mainGroup) {
        state.addresses.addWithoutUpdate(mainGroup);
        mainGroup.name = name;
      } else {
        mainGroup = GroupAddress.createNewGroupAddress({
          level: 1,
          name: name,
          parent: state.addresses,
        });

        room.groupAddress = mainGroup;
      }
      // Create Consumer Addresses

      room.consumers
        .sortBy("tagOrName")
        .filter((c) => !channelTypeInfo(c.channelType).isSupply)
        .forEach((consumer) => {
          generateAddressesForConsumer_B(consumer, mainGroup);
        });

      let middleGroup7 = getGaFromCollection(mainGroup.children, (a) => a.address == "7");
      if (middleGroup7) {
        middleGroup7.name = itx("components.plural.Button", `Taster`);
      } else {
        middleGroup7 = GroupAddress.createNewGroupAddress({
          level: 2,
          name: itx("components.plural.Button", `Taster`),
          address: 7,
          parent: mainGroup,
        });
      }

      room.buttons.sortBy("tagOrName").forEach((button) => {
        createButtonAddresses_3(button, middleGroup7);
      });

      if (middleGroup7.children.size == 0) {
        mainGroup.children.removeWithoutUpdate(middleGroup7);
      }
    });
  });
}
